module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/flow_02-a5f66406f8631ac9dc5faf3b9b24f59a.png";